import React, {
  useEffect,
  useState,
} from 'react';
import {
  Flex,
  Box,
} from 'reflexbox/styled-components';
import {
  utils,
} from 'ethers';
import styled from 'styled-components';
import {
  useWeb3React,
} from '@web3-react/core';

import Confetti from '../../components/confetti';

import FailImg from '../../assets/img/fail.png';
import SuccessImg from '../../assets/img/success.png';

import {
  Input,
  Button,
  Spinner,
} from '../../style/components';

import {
  isClaimed,
  getAmount,
  claim,
} from '../../utils/merkleDistributor';

const CardWrapper = styled(Box)`
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);
  border-radius: 23px;
`;

const CardHeader = styled(Box)`
  /* background: linear-gradient(245deg, #ff3b81 136%, #ff69bb -11%); */
  /* background-image: linear-gradient(236deg, #ff6db7 116%, #ff3b81 -18%); */
  background-color: ${(props) => props.theme.colors.primary};
  border-radius: 23px 23px 0 0;
`;

const CardBody = styled(Box)`
  border-radius: 0 0 23px 23px;
  background-color: #ffffff;
`;

const ReceivingAddressTitle = styled.h2`
  font-family: ${(props) => props.theme.font.family};
  font-weight: ${(props) => props.theme.font.weight.bold};
  color: ${(props) => props.theme.colors.header};
  font-size: 22px;
  line-height: 1.27;
  margin: 0;
`;

const Description = styled.p`
  font-family: ${(props) => props.theme.font.family};
  font-size: ${(props) => props.theme.font.size.regular};
  font-weight: ${(props) => props.theme.font.weight.medium};
  line-height: 1.43;
  color: #c1c8cf;
`;

const ClaimTitle = styled.h4`
  font-family: ${(props) => props.theme.font.family};
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #ffffff;
  margin: 10px 0 0 0;
`;

const Amount = styled.h3`
  font-family: CartographMonoCF;
  font-size: 48px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.58;
  letter-spacing: normal;
  color: #ffffff;
  margin: 0;
  display: inline-block;
`;

const ConfirmedAmount = styled.h3`
  font-family: CartographMonoCF;
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.77;
  letter-spacing: 0.31px;
  text-align: center;
  color: ${(props) => props.theme.colors.header};
  margin: 0;
`;

const ConfirmedLabel = styled.h4`
  font-family: ${(props) => props.theme.font.family};
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.11;
  letter-spacing: 0.22px;
  text-align: center;
  color: #7f7f7f;
  margin: 0;
`;

const Uni = styled.span`
  opacity: 0.4;
  font-family: ${(props) => props.theme.font.family};
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: normal;
  color: #ffffff;
  margin-left: 10px;
`;

const StatusIcon = styled.img`
  height: 68px;
`;

const ConnectWalletWarning = styled.p`
  color: ${(props) => props.theme.colors.primary};
  font-family: ${(props) => props.theme.font.family};
  font-size: ${(props) => props.theme.font.size.regular};
  font-weight: ${(props) => props.theme.font.weight.regular};
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  margin-bottom: 0;
`;

function Home() {
  const {
    account,
    library,
  } = useWeb3React();

  const [targetAddress, setTargetAddress] = useState<string>('');
  const [amountToClaim, setAmountToClaim] = useState<string>('0');
  const [canClaim, setCanClaim] = useState<boolean>(false);

  const [startConfetti, setStartConfetti] = useState<boolean>(false);

  const [isConfirming, setIsConfirming] = useState<boolean>(false);
  const [status, setStatus] = useState<string>('none');

  useEffect(() => {
    async function verifyUni() {
      try {
        const amount = await getAmount(targetAddress);

        if (amount !== '0') {
          const res = await isClaimed(library, targetAddress);

          if (res === false) {
            const amountArray = amount.split('.');
            const decimals = amountArray[1];
            setAmountToClaim(`${amountArray[0]}.${decimals.substring(0, 2)}`);
            setCanClaim(true);
          } else {
            setAmountToClaim('0');
            setCanClaim(false);
          }
        } else {
          setCanClaim(false);
          setAmountToClaim('0');
        }
      } catch (e) {
        console.log(e);
      }
    }

    if (library && utils.isAddress(targetAddress)) {
      verifyUni();
    } else {
      setAmountToClaim('0');
    }
  }, [library, targetAddress]);

  useEffect(() => {
    if (account !== null && account) {
      setTargetAddress(account);
    }
  }, [account]);

  function returnCardContent() {
    if (status === 'confirmed') {
      return (
        <Box
          p={5}
          textAlign="center"
        >
          <Box
            pb={3}
          >
            <StatusIcon src={SuccessImg} alt="Success icon" />
          </Box>
          <Box
            pb={3}
            px={3}
          >
            <Description>
              Your claim was successful! The funds were sent directly to the wallet.
            </Description>
          </Box>
          <Box
            pb={3}
          >
            <ConfirmedAmount>
              {`${amountToClaim} UNI`}
            </ConfirmedAmount>
          </Box>
          <Box>
            <ConfirmedLabel>
              Claimed
            </ConfirmedLabel>
          </Box>
          <Box
            pt={5}
          >
            <Button
              genre="primary"
              onClick={() => {
                setTargetAddress('');
                setAmountToClaim('0');
                setStatus('none');
              }}
            >
              Claim again
            </Button>
          </Box>
        </Box>
      );
    }

    if (status === 'failed') {
      return (
        <Box
          p={5}
          textAlign="center"
        >
          <Box
            pb={3}
          >
            <StatusIcon src={FailImg} alt="Fail icon" />
          </Box>
          <Box
            pb={3}
            px={3}
          >
            <Description>
              Your claim has failed! The funds were not sent...
            </Description>
          </Box>
          <Box
            pt={5}
          >
            <Button
              genre="primary"
              onClick={() => {
                setTargetAddress('');
                setAmountToClaim('0');
                setStatus('none');
              }}
            >
              Try again
            </Button>
          </Box>
        </Box>
      );
    }

    return (
      <Box width={1}>
        <CardHeader
          width={1}
          p="42px"
          textAlign="center"
        >
          <Amount>
            {amountToClaim}
          </Amount>
          <Uni>
            UNI
          </Uni>
          <ClaimTitle>
            Claim UNI Token
          </ClaimTitle>
        </CardHeader>
        <CardBody
          width={1}
          p={4}
        >
          <Box
            width={1}
          >
            <ReceivingAddressTitle>
              Receiving Address
            </ReceivingAddressTitle>
            <Description>
              Enter an address to trigger a UNI claim. If the address has any claimable UNI it will be sent to them on submission.
            </Description>
          </Box>
          <Box
            width={1}
            pt={3}
            pb={4}
          >
            <Input
              placeholder="Wallet Address or ENS name"
              onChange={(e) => setTargetAddress(e.target.value)}
              value={targetAddress}
              maxLength={42}
              block
            />
          </Box>
          <Box
            width={1}
            textAlign="center"
          >
            <Button
              genre="primary"
              disabled={utils.isAddress(targetAddress) === false || !canClaim || !account}
              onClick={async () => {
                setIsConfirming(true);

                try {
                  const receipt = await claim(
                    library,
                    targetAddress,
                  );

                  console.log(receipt);
                  setStartConfetti(true);
                  setStatus('confirmed');
                } catch (e) {
                  setStatus('failed');
                  console.log(e);
                } finally {
                  setIsConfirming(false);
                }
              }}
            >
              {isConfirming ? (
                <Flex
                  alignItems="center"
                  justifyContent="center"
                >
                  <Spinner color="#ffffff" />
                  Confirming...
                </Flex>
              ) : (
                <>
                  Claim UNI
                </>
              )}
            </Button>
            {account === null && (
              <ConnectWalletWarning>
                Please connect a wallet to claim UNI tokens.
              </ConnectWalletWarning>
            )}
          </Box>
        </CardBody>
      </Box>
    );
  }

  return (
    <Flex
      width={1}
      p={3}
    >
      <Confetti run={startConfetti} />
      <CardWrapper
        display="flex"
        width={[1, 1 / 2, 1 / 3]}
        maxWidth={520}
        minHeight={460}
        mx="auto"
        alignItems="center"
      >
        {returnCardContent()}
      </CardWrapper>
    </Flex>
  );
}

export default Home;
